import { render, staticRenderFns } from "./MaterialShipments.vue?vue&type=template&id=4ed9b8ac&"
import script from "./MaterialShipments.vue?vue&type=script&lang=js&"
export * from "./MaterialShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports